<template>
  <div class="new-dashboard-container">
    <!-- The Radial Menu component will go here -->
    <RadialMenu />
  </div>
</template>

<script setup>
import RadialMenu from '@/components/RadialMenu.vue';
</script>

<style scoped>
.new-dashboard-container {
  /* MODIFIED: Changed positioning to be more robust for full-screen */
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 40; /* Position it below the main nav bar (which has z-50) */

  /* Layout */
  display: flex;
  justify-content: center;
  align-items: center;
  
  /* Styling */
  background-color: #0c0c0e; /* Dark futuristic background color */
  background-image: url('@/assets/futuristic-bg.jpg'); /* Using your provided background */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  overflow: hidden; /* Hide any overflow */
}
</style>